const esc = (val) => {
  const s = String(val ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

// Build a CSV string from columns [{key,label}] and rows. Optional cell(row,col) formatter.
export const rowsToCsv = (columns, rows, cell) => {
  const header = columns.map((c) => esc(c.label)).join(",");
  const body = (rows || []).map((r) => columns.map((c) => esc(cell ? cell(r, c) : r[c.key])).join(",")).join("\n");
  return `${header}\n${body}`;
};

// Trigger a browser download of a CSV string.
export const downloadCsv = (filename, csv) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
